<template>
  <div class="player player-notebook" :class="{'show': display}">
    <div class="container">
      <i class="icon-close-1 player-close" @click="playerClose"></i>
      <!-- 图片区域 -->
      <div class="image-area">
        <div class="image-swiper" id="imageBox" ref="imageBox" v-scroll="zoom">
          <swiper :options="swiperOption" ref="mySwiper"  @transitionEnd="imageTransitionEnd">
            <swiper-slide v-for="image in images" :key="image.id">
              <div class="image-wrapper">
                <img class="swiper-image" :src="image.url" v-bind:style="{ transform: 'scale(' + image.imageScale + ')'}" alt="">
              </div>
            </swiper-slide>
          </swiper>
          <!-- OCR结果显示区域 -->
          <div class="ocr-container" :class="{'show': ocrProcess}">
            <div class="wrapper">
              <i class="icon-close-1" @click="closeOCRPannel"></i>
              <div class="ocr-content">
                <div class="ocr-result-text" v-if="!showNoOcr">{{imageObj.ocrContent}}</div>
                <div class="ocr-result-text no-ocr" v-if="showNoOcr">
                  <div class="text-1">{{$t('player.noOcrResult')}}</div>
                  <div class="text-2">{{$t('player.ocrTip')}}</div>
                </div>
                <processing :ocrLoading="ocrLoading"></processing>
              </div>
              <div class="copy-btn" v-if="!showNoOcr">
                <i class="icon-copy" @click="copyOcrContent"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 左右导航区域 -->
        <div class="swiper-nav left">
          <div class="nav-container" :class="{'grey': index <= 0}" @click="navImage(-1)">
            <i class="icon-prev"></i>
          </div>
        </div>
        <div class="swiper-nav right">
          <div class="nav-container" :class="{'grey': index >= images.length - 1}" @click="navImage(1)">
            <i class="icon-next"></i>
          </div>
        </div>
      </div>
      <!-- 工具栏区域 -->
      <div class="player-toolbar">
        <div class="toolbar-container">
          <!-- 下载 -->
          <div class="toolbar-item" @click="downloadImage">
            <span class="tool icon-download-1"></span>
          </div>
          <!-- 分享 -->
          <div class="toolbar-item" @click="openShareBox">
            <span class="tool icon-share-1"></span>
          </div>
          <!-- OCR -->
          <div class="toolbar-item" @click="imageOCRProcess">
            <span class="tool icon-handwritten-recognition"></span>
          </div>
        </div>
      </div>
      <processing :processing="processing"></processing>
    </div>
    <share-box v-if="showShareBox" :images="shareImages" :shareType="0" v-on:toCloseShareBox="closeShareBox"></share-box>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import ShareBox from './ShareBox'
import processing from './Processing'
export default {
  name: 'player',
  props: {
    images: Array,
    show: Boolean,
    allIndex: Number
  },
  components: {
    swiper,
    swiperSlide,
    ShareBox,
    processing
  },
  data () {
    return {
      swiperOption: {
        // 鼠标模拟手机触摸，默认为true，false鼠标拖动无效，移动端仍可正常滑动
        simulateTouch: false,
        // 默认为true，强制加载所有图片
        preloadImages: false
      },
      index: 0,
      ocrProcess: false,
      reloadData: false,
      playerTransition: false,
      showShareBox: false,
      pendingOcrKey: '',
      processing: false,
      ocrLoading: true,
      showNoOcr: false
    }
  },
  created () {
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    display () {
      return this.show
    },
    imageObj () {
      if (this.images.length > 0) {
        return this.images[this.index]
      } else {
        return {}
      }
    },
    shareImages () {
      return [this.imageObj]
    }
  },
  methods: {
    copyOcrContent: function () {
      if (this.imageObj.ocrContent === null) return
      var thisObj = this
      this.$copyText(this.imageObj.ocrContent).then(function (e) {
        thisObj.$toasted.show(thisObj.$t('player.copyToClipboard'), {
          duration: 2000,
          position: 'bottom-right',
          containerClass: 'ocr-content-body',
          singleton: true
        })
      }, function (e) {
        // console.log(e)
      })
    },
    closeOCRPannel: function () {
      this.ocrProcess = false
    },
    imageOCRProcess: function () {
      this.ocrProcess = !this.ocrProcess
      if (this.ocrProcess) {
        this.imageOcrSwitch()
      }
    },
    imageOcrSwitch: function () {
      this.ocrLoading = true
      HttpClient.getData(Config.APP_HOST + '/v1/book/getOcrContentById?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&id=' + this.imageObj.id, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.ocrLoading = false
          if (response.body !== null) {
            this.imageObj.ocrContent = response.body
            this.showNoOcr = false
          } else {
            this.showNoOcr = true
          }
        }
      })
    },
    closeShareBox: function () {
      this.showShareBox = false
    },
    openShareBox: function () {
      this.showShareBox = true
    },
    downloadImage: function () {
      HttpClient.postData(Config.APP_HOST + '/v1/book/downloadPage', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        pageId: this.images[this.index].id
      }, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          window.location.href = response.body.downloadUrl
          // window.open(response.body.downloadUrl, '_blank')
        }
      })
    },
    showImage: function (index) {
      this.index = index
      this.reloadData = false
      this.swiper.slideTo(this.index, 0, false)
    },
    cancelReload: function () {
      this.reloadData = false
    },
    navImage: function (offset) {
      this.ocrProcess = false
      if (this.reloadData || this.playerTransition) { return }
      var index = this.index
      index += offset
      if (index < 0) {
        index = 0
      }
      if (index >= this.images.length) {
        index = this.images.length - 1
      }
      if (index !== this.index) {
        this.index = index
        this.playerTransition = true
        this.swiper.slideTo(this.index, 600, false)
      }
    },
    imageTransitionEnd: function () {
      if (this.swiper.previousIndex !== undefined) {
        this.resetImageConfig(this.swiper.previousIndex)
      }
      this.playerTransition = false
      if ((this.allIndex !== 0 && this.index === 1) || this.index === this.images.length - 2) {
        this.reloadData = true
        this.$emit('reloadPlayerData', this.index)
      }
    },
    resetImageConfig: function (index) {
      if (this.images[index]) {
        this.images[index].imageScale = 1
      }
      this.ocrProcess = false
    },
    zoom: function (event) {
      if (this.ocrProcess) return
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
      var scale = this.images[this.index].imageScale
      scale = scale * Math.pow(1.01, event.wheelDelta)
      if (scale > 0.2 && scale < 4) {
        this.images[this.index].imageScale = scale
      }
    },
    playerClose: function () {
      this.$emit('closeButtonClick')
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
_toolbar-height = 204px
.player-notebook
  position fixed
  display none
  width 100%
  height 100%
  top 0px
  left 0px
  z-index 999
  &.show
    display block
  .container
    position relative
    display block
    width 100%
    height 100%
    background-color rgba(0,0,0,0.4)
    padding-bottom _toolbar-height - 120px
    box-sizing border-box
    .player-close
      position absolute
      display block
      top 50px
      right 20px
      color #FFFFFF
      font-size 28px
      cursor pointer
      z-index 1002
    .image-area
      position relative
      display flex
      flex-direction column
      justify-content center
      align-items center
      width 100%
      height 100%
      padding 40px 60px 10px
      box-sizing border-box
      .image-swiper
        position relative
        display block
        width 100%
        height 100%
        overflow hidden
        .ocr-container
          position absolute
          display block
          top 0px
          right -240px
          height 100%
          width 240px
          background-color #FFFFFF
          border 1px solid #f5f5f5
          transition all 0.3s ease-in
          z-index 10099
          box-sizing border-box
          &.show
            right 0px
          .wrapper
            position relative
            display block
            width 100%
            height 100%
            padding 56px 22px 66px
            box-sizing border-box
            .icon-close-1
              position absolute
              display block
              top 10px
              right 10px
              font-size 16px
              cursor pointer
            .ocr-content
              display flex
              width 100%
              height 100%
              justify-content center
              align-items center
              .ocr-option
                position absolute
                display block
                width 100%
                height 24px
                left 0px
                top 0px
                line-height 24px
                text-align left
                .icon-message
                  display inline-block
                  font-size 24px
                  float left
                .ocr-language
                  position relative
                  display inline-block
                  min-width 100px
                  margin-left 4px
                  padding 0px 4px
                  cursor pointer
                  border 1px solid rgba(61, 61, 61, 0)
                  border-bottom none
                  background-color #ffffff
                  &.active
                    .language-list
                      height 196px
                      border-radius 4px
                      border 1px solid rgba(0, 0, 0, 0.05)
                      box-shadow: 0px 0px 20px 0px rgba(39, 47, 68, 0.05)
                      overflow-y auto
                  .language-text
                    display inline-block
                    font-size 14px
                    width 70px
                  .icon-down-arrow
                    font-size 12px
                  .language-list
                    position absolute
                    top 30px
                    left -1px
                    width 100px
                    height 0px
                    overflow hidden
                    box-sizing border-box
                    overflow hidden
                    border 1px solid rgba(61, 61, 61, 0)
                    background-color #ffffff
                    transition height 0.3s ease-in
                    border-radius 4px
                    z-index 999
                    .item
                      display block
                      width 100%
                      height 24px
                      padding 0px 4px
                      line-height 24px
                      font-size 14px
                      box-sizing border-box
                      &:hover
                        background-color #ebebeb
                      &.active
                        background-color #ebebeb
              .ocr-result-text
                height 100%
                line-height 18px
                &.no-ocr
                  display block
                  height auto
                  color #999
                  text-align center
                  padding-top 5px
                  .text-1
                    width 100%
                    font-size 24px
                    font-weight bold
                  .text-2
                    width 68%
                    font-size 12px
                    line-height 18px
                    margin-top 10px
                    margin-left 16%
            .copy-btn
              position absolute
              display flex
              flex-direction row
              justify-content center
              align-items center
              width 100%
              height 60px
              left 0px
              bottom 0px
              font-size 20px
              line-height 60px
              .icon-copy
                display block
                cursor pointer
      .swiper-nav
        position absolute
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 60px
        height 100%
        top 0px
        .nav-container
          display flex
          width 100%
          height 70%
          flex-direction column
          justify-content center
          align-items center
          i
            color #FFFFFF
            font-size 48px
            cursor pointer
          &.grey
            i
              color rgba(255, 255, 255, 0.2)
              cursor default
        &.left
          left 0px
        &.right
          right 0px
    .player-toolbar
      position absolute
      display flex
      width 100%
      height _toolbar-height
      left 0px
      bottom 0px
      padding-bottom 36px
      flex-direction column
      justify-content flex-end
      align-items center
      background-image url('../../assets/images/player_toolbar_bg.png')
      background-repeat repeat-x
      background-position center left
      box-sizing border-box
      .toolbar-container
        display flex
        width 326px
        height 56px
        flex-direction row
        justify-content space-around
        align-items center
        .toolbar-item
          position relative
          display flex
          flex-direction row
          justify-content center
          align-items center
          width 42px
          height 26px
          &.show
            .tool-gropdown
              opacity 1
              &.page-mode
                height 49px
              &.color-mode
                height 111px
            .arrow
              color #fafafa
          .tool
            color #a1a1a1
            font-size 30px
            cursor pointer
            &:hover
              color #FFFFFF
          .arrow
            color #a1a1a1
            font-size 12px
          .tool-gropdown
            position absolute
            display flex
            width 80px
            height 0px
            left 30px
            bottom 22px
            flex-direction column
            justify-content flex-start
            align-items flex-start
            background-color rgba(0,0,0,0.8)
            border-radius 4px
            color #939393
            font-size 13px
            z-index 1002
            overflow hidden
            box-sizing border-box
            opacity 0
            transition all 0.3s ease
            padding 4px 0
            .option
              display block
              padding 4px 6px
              box-sizing border-box
              text-align left
              cursor pointer
              &:hover
                color #FFFFFF
              .icon-select
                display none
                padding-left 4px
                font-size 12px
              &.active
                color #FFFFFF
                .icon-select
                  display inline-block
.image-swiper
  .viewer
    width 100%
    height 100%
    img
      display none
  &.image-static
    .viewer-transition
      transition all 0.4s ease
  .viewer-transition
    transition all 0.4s ease
.swiper-container
  display block
  width 100%
  height 100%
  .swiper-wrapper
    .swiper-slide
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding 0 20px
      box-sizing border-box
      .image-wrapper
        display flex
        position relative
        width 100%
        height 100%
        overflow hidden
        flex-direction column
        justify-content center
        align-items center
        overflow hidden
        color #FFFFFF
        .swiper-image
          max-width 100%
          max-height 100%
          transition all 0.2s
          &.static
            transition none
</style>



// WEBPACK FOOTER //
// src/components/Notebook/Player.vue